import { BookBar, DateSearchBar, PieceBanner, ReservationList } from "@/domains/components";
import { useGetReserve, type ReserveBaseResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { CustomCenter, CustomText } from "./reservation.style";

export const Reservation = () => {
    const { data } = useGetReserve<ReserveBaseResponse>({ section: "reserve" });
    const { isLaptop } = MEDIA();

    return data ? (
        <Box w="100%" position="relative">
            <PieceBanner
                imgUrl={data.imgUrl}
                name={data.pensionInfo.name}
                title={{
                    main: "Reservation",
                    sub: "실시간 예약조회",
                }}
            />
            <CustomCenter
                as="section"
                p={isLaptop ? "64px 20px" : "128px 0 64px"}
                position="relative"
                flexDir="column"
                rowGap="36px"
            >
                <DateSearchBar isSubMenu={false} />
                <CustomText as="h5">객실 선택</CustomText>
                <ReservationList />
            </CustomCenter>
            <BookBar />
        </Box>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
